import { connect } from 'react-redux';
import { getMatrixOptionCount, getMatrixLabelList } from '../../../reducers';

const mapStateToProps = (state, { form, initialValues, block }) => ({
  labelList: getMatrixLabelList({ state, form, initialValues, block }),
  optionsCount: getMatrixOptionCount({ state, form, initialValues, block }),
});

export default connect(mapStateToProps);
